module.exports = __webpack_public_path__ + "img/annualreport.e011168c.png";